<div class="page bg-black">
  <div class="background">
    <picture>
      @for (width of imgWidths; track $index) {
        <source
          [srcset]="imgPath + '/start/Alex-w' + width + '.webp'"
          media="(min-width: {{ width }}px), (min-height: {{ width / 2 }}px)" />
      }
      <img [src]="imgPath + '/start/Alex-w2000.webp'" alt="Alexander Schwartz start page background image" class="foreground-image" />
    </picture>

    <mat-card class="my-services-card">
      <mat-card-title (click)="goToMyServices()" class="text-shadow-primary my-services-card-title hover-pointer"
        >Meine Leistungen
      </mat-card-title>
      <ul>
        <li class="text-shadow-primary hover-pointer" routerLink="software-development">Software-Entwicklung</li>
        <li class="text-shadow-primary hover-pointer" routerLink="photography">Fotografie</li>
        <li class="text-shadow-primary hover-pointer" routerLink="real-estate">Immobilieninvestments</li>
        <li class="text-shadow-primary hover-pointer" routerLink="blitzshare">Blitzshare</li>
        <li class="text-shadow-primary hover-pointer" routerLink="trump-post-alert">Trump Post Alert</li>
      </ul>
    </mat-card>
  </div>

  <div class="service-grid" id="my-services">
    <div class="card service-card">
      <img
        [src]="imgPath + '/start/software-development.webp'"
        alt="Software-Entwicklung"
        class="service-image no-scale-crop top-rounded-image hover-pointer crop-top-left"
        routerLink="software-development" />
      <div class="card-body">
        <h5 class="card-title">Software-Entwicklung</h5>
        <p class="card-text">{{ LEAD_SOFTWARE_DEVELOPER }}</p>
      </div>
      <div class="card-footer">
        <button class="w-100" color="primary" mat-flat-button routerLink="software-development">Mehr erfahren</button>
      </div>
    </div>
    <div class="card service-card">
      <picture class="hover-pointer" routerLink="trump-post-alert">
        @for (width of trumpImageWidths; track $index) {
          <source
            [srcset]="imgPath + '/start/trump-post-alert-w' + width + '.webp'"
            media="(min-width: {{ width }}px), (min-height: {{ width / 2 }}px)" />
        }
        <img
          [src]="trumpFallbackImage"
          alt="Trump Post Alert"
          class="service-image scale-cover top-rounded-image hover-pointer crop-top-left" />
      </picture>
      <div class="card-body">
        <h5 class="card-title">Trump Post Alert</h5>
        <p class="card-text">{{ LEAD_TRUMP_POST_ALERT }}</p>
      </div>
      <div class="card-footer">
        <button class="w-100" color="primary" mat-flat-button routerLink="trump-post-alert">Mehr erfahren</button>
      </div>
    </div>

    <div class="card service-card">
      <img
        [src]="imgPath + '/start/blitzshare-canoe-w500.webp'"
        alt="Blitzshare"
        class="service-image scale-cover top-rounded-image hover-pointer crop-center"
        routerLink="blitzshare" />
      <div class="card-body">
        <h5 class="card-title">Blitzshare</h5>
        <p class="card-text">{{ LEAD_BLITZSHARE }}</p>
      </div>
      <div class="card-footer">
        <button class="w-100" color="primary" mat-flat-button routerLink="blitzshare">Mehr erfahren</button>
      </div>
    </div>

    <div class="card service-card">
      <img
        [src]="imgPath + '/start/photographer-w500.webp'"
        alt="Fotografie"
        class="service-image scale-cover top-rounded-image hover-pointer crop-top"
        routerLink="photography" />
      <div class="card-body">
        <h5 class="card-title">Fotografie</h5>
        <p class="card-text">{{ LEAD_PHOTOGRAPHY }}</p>
      </div>
      <div class="card-footer">
        <button class="w-100" color="primary" mat-flat-button routerLink="photography">Mehr erfahren</button>
      </div>
    </div>

    <div class="card service-card">
      <img
        [src]="imgPath + '/start/real-estate-w500.webp'"
        alt="Immobilien"
        class="service-image scale-cover top-rounded-image hover-pointer crop-top"
        routerLink="real-estate" />
      <div class="card-body">
        <h5 class="card-title">Immobilien</h5>
        <p class="card-text">{{ LEAD_REAL_ESTATE }}</p>
      </div>
      <div class="card-footer">
        <button class="w-100" color="primary" mat-flat-button routerLink="real-estate">Mehr erfahren</button>
      </div>
    </div>
  </div>
</div>
